import { Record } from 'immutable';
import Hydrator from 'utils/Hydrator';

const CreditLineLedgerRecord = Record({
  balance: 0,
  updatedAt: new Date(0),
});

export default class CreditLineLedger extends CreditLineLedgerRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      updatedAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CreditLineLedger(hydrated);
  }
}
